import React from 'react';

interface FilterChipProps {
  active: boolean;
  label: string;
  mainColor: string; // e.g. bg-emerald-500
  lightColor: string; // e.g. bg-emerald-50
  textColor: string; // e.g. text-emerald-700
  borderColor: string; // e.g. border-emerald-500
  count: number;
  onClick: () => void;
}

const FilterChip: React.FC<FilterChipProps> = ({
  active,
  label,
  mainColor,
  lightColor,
  textColor,
  borderColor,
  count,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium border transition-transform duration-200
        ${
          active
            ? `${lightColor} ${textColor} ${borderColor} shadow-sm hover:shadow transform hover:scale-[1.02]`
            : 'bg-white dark:bg-gray-100 contrast:bg-gray-100 text-gray-600 contrast:text-gray-900 border-gray-400 hover:bg-gray-50 hover:border-gray-400 transform hover:scale-[1.02]'
        }
      `}
    >
      <span className={`w-2 h-2 rounded-full ${mainColor}`}></span>
      <span>{label}</span>
      <span
        className={`px-1.5 py-0.5 rounded-full text-xs ${
          active
            ? 'bg-white !text-gray-900 border border-gray-300 dark:bg-white dark:!text-black dark:border-gray-700 contrast:bg-white contrast:!text-black contrast:border-black'
            : 'bg-gray-100 dark:bg-gray-300 text-gray-600 dark:text-gray-900 contrast:bg-white contrast:!text-black contrast:border-black'
        }`}
      >
        {count}
      </span>
    </button>
  );
};

export default FilterChip;
